import { COLORS } from '@btime/constants'
import React from 'react'

import { HorizontalLine } from '../../../components/shapes/Line'
import { TabsContext } from '../../../components/tabs/TabsContext'
import { tabsOptions } from './data/tabsOptions'
import ChecklistLoader from './_load/ChecklistLoader'
import ControlledModal from '../../../components/modals/ControlledModal'
import ModalHeader from './ModalHeader'
import Separator from '../../../components/helpers/Separator'
import TabsContent from '../../../components/tabs/TabsContent'

const ShowChecklistModal = props => {
  return (
    <ControlledModal width="48rem" {...props}>
      <ChecklistLoader>
        <TabsContext options={tabsOptions}>
          <ModalHeader />
          <HorizontalLine thin lineColor={COLORS.light2} />
          <Separator weight={4} />

          <TabsContent />
        </TabsContext>
      </ChecklistLoader>
    </ControlledModal>
  )
}

export default ShowChecklistModal
